import React, { Fragment, useEffect, useState } from "react";
import { arrayOf, shape, string, func, object, bool } from "prop-types";
import { Link } from "react-router-dom";
import ReadingStatus from "../ReadingListDownload/reading_status";
import * as style from "../ReadingListDownload/styles.module.scss";
import * as myStyles from "./styles.module.scss";
import OnboardingListItem from "../OnboardingListItem/OnboardingListItem";
import OnboardingSection from "../../common/OnboardingSectionCreator/OnboardingSection";
import { getCarltonForestForm } from "../../api/profileApi";

const filenameFromUrl = (url) => url.split("/").slice(-1)[0];

const CarltonForestOnboarding = ({
  readingList,
  carltonForestOnboarding,
  markDocumentRead,
  carltonForestReadingLoading,
  postSSOWCarltonForest,
  SSOWLoading,
  SSOWHandBaller,
  SSOWMaterialHandling,
  SSOWItemsLoading,
  carltonForestInductionFormLoading,
}) => {
  const [currentlyReading, setCurrentlyReading] = useState(null);
  const [showCheckbox, setShowCheckbox] = useState("");
  const [content, showContent] = useState("");
  const [loading, setLoading] = useState(false);
  const [curTypeCode, setCurTypeCode] = useState("");

  const readDocuments =
    (carltonForestOnboarding && carltonForestOnboarding.readDocuments) || [];

  const SSOWsHandBaller =
    (carltonForestOnboarding && carltonForestOnboarding.SSOWHandBaller) || [];

  const SSOWsMaterialHandling =
    (carltonForestOnboarding && carltonForestOnboarding.SSOWMaterialHandling) ||
    [];

  const triggerDownload = () => {
    setLoading(true);
    getCarltonForestForm().then((response) => {
      const link = document.createElement("a");
      const blob = new Blob([response.data], {
        type: "application/pdf",
      });
      link.href = window.URL.createObjectURL(blob);
      link.download = `Carlton Forest Induction Form.pdf`;
      link.click();
      setLoading(false);
    });
  };

  const readingListWithStatus = readingList
    .map((download) => ({
      ...download,
      status: readDocuments.includes(filenameFromUrl(download.link))
        ? ReadingStatus.Done
        : ReadingStatus.Todo,
    }))
    .sort((a, b) => a.title.localeCompare(b.title));

  const submitted = false;

  useEffect(() => {
    setLoading(false);
  }, [submitted]);

  const formsListWithStatus = [
    {
      status: carltonForestOnboarding.inductionForm
        ? ReadingStatus.Done
        : ReadingStatus.Todo,
      title: "Induction Checklist",
      submitted: carltonForestOnboarding.YCFG,
      url: "carlton-forest-onboarding/induction",
      text: "Complete",
      loading: loading && curTypeCode === "YCFG",
      handleClick:
        carltonForestOnboarding.YCFG === true ? triggerDownload : null,
      disabled: carltonForestInductionFormLoading,
    },
  ];

  const listOfSSOWs = [
    {
      line: "Hand Baller Operative",
      docs: SSOWHandBaller || [],
      statusFor: SSOWsHandBaller,
      formName: "handBaller",
    },
    {
      line: "MHE Operative",
      docs: SSOWMaterialHandling || [],
      statusFor: SSOWsMaterialHandling,
      formName: "mhe",
    },
  ];

  const isiOSDevice = () => {
    return (
      [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod",
      ].includes(navigator.platform) ||
      // iPad on iOS 13 detection
      (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    );
  };

  useEffect(() => {}, [showCheckbox, currentlyReading]);

  const isDownloadAttrSupported = () =>
    "download" in document.createElement("a");

  const handleReading = (event, title, link) => {
    window.open(link, "_blank");
    if (isiOSDevice() || !isDownloadAttrSupported()) {
      event.preventDefault();
    }

    setShowCheckbox(title);
  };
  const handleCompletedReading = (event, title, link) => {
    window.open(link, "_blank");
    if (isiOSDevice() || !isDownloadAttrSupported()) {
      event.preventDefault();
    }
  };

  const currentDate = new Date(Date.now());
  const handleCheckbox = (formName, el) => {
    postSSOWCarltonForest(formName, {
      [el.title]: currentDate.toISOString(),
    });
    setShowCheckbox("");
  };

  return (
    <div className="container text-bluishGray pb-2">
      <header className="row">
        <div className="col-12">
          <h2 className="section-header pt-2">Carlton Forest Induction</h2>
        </div>
      </header>
      <div className="row">
        <div className="col-lg-6">
          <OnboardingSection
            title="Reading List"
            subtext="You are required to download and read each handbook below before you start work. You will then be asked to tick the box to confirm you have read and understood and agree to each handbook. If you have any queries about the handbooks, please speak to your line manager."
            readingListWithStatus={readingListWithStatus}
            currentlyReading={currentlyReading}
            setCurrentlyReading={setCurrentlyReading}
            markDocumentRead={markDocumentRead}
            isLoading={carltonForestReadingLoading}
            submit={() => {}}
          />
        </div>
        <div className="col-lg-6">
          <div className="mt-1 mt-lg-0">
            <OnboardingSection
              title="Forms"
              formsListWithStatus={formsListWithStatus}
              submit={() => {}}
            />
            <div
              className={`${myStyles.readingList__wrapper} section-body pt-1 mt-1 bg-white`}
            >
              <h5 className="px-1">SSOW ( Safe System of Work Procedure )</h5>
              <p className="px-1">
                Please only read the documents related to your role.
              </p>
              {listOfSSOWs.map((el) => (
                <Fragment key={el.formName}>
                  <div
                    style={{
                      fontWeight: "700",
                      cursor: "pointer",
                      padding: "20px",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                    className="styles__onboarding__wrapper___3a5Dz items-center flex-row mb6-0"
                    onClick={() =>
                      showContent(content === el.line ? "" : el.line)
                    }
                  >
                    <p>{el.line}</p>

                    <img
                      style={{ margin: "8px" }}
                      src="https://www.hrgo.co.uk/images/nav/nav-arrow-down.svg"
                      className={`${content === el.line && style.rotateimg180}`}
                      width="10px"
                      height="10px"
                    />
                  </div>
                  {content === el.line &&
                    el.docs.map((element, index) => {
                      return showCheckbox === element.title ? (
                        <div
                          key={index}
                          className={`${style.rldownload__wrapper} ${style.rldownload__wrapper__reading}`}
                        >
                          <span className={style.rldownload__agreement}>
                            <input
                              type="checkbox"
                              name="document_read"
                              value={element.title}
                              onClick={() =>
                                handleCheckbox(el.formName, element, index)
                              }
                            />
                            {`I have read and understood ${element.title}`}
                          </span>
                          <button
                            onClick={() => setShowCheckbox(null)}
                            className={`${style.rldownload__button} btn btn-md btn-outline mx-1 mx-sm-0`}
                          >
                            Cancel
                          </button>
                        </div>
                      ) : (
                        <OnboardingListItem
                          loading={SSOWLoading === element.title}
                          title={element.title}
                          status={el.statusFor[element.title] ? 3 : 1}
                          key={index}
                          btnText="Download"
                          disabled={SSOWItemsLoading}
                          handleClick={(e) =>
                            handleReading(e, element.title, element.link)
                          }
                          handleCustomClick={(e) => {
                            handleCompletedReading(
                              e,
                              element.title,
                              element.link
                            );
                          }}
                          downloadingDisabled={false}
                        />
                      );
                    })}
                </Fragment>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div
        className={`${myStyles.button__wrapper} d-flex justify-content-end mt-4`}
      >
        <Link to="/profile" className="btn btn-primary px-3">
          Back to My Account
        </Link>
      </div>
    </div>
  );
};

CarltonForestOnboarding.propTypes = {
  markDocumentRead: func.isRequired,
  carltonForestOnboarding: object,
  carltonForestReadingLoading: bool,
  carltonForestInductionFormStatus: string,
  SSOWLoading: string,
  postSSOWCarltonForest: func.isRequired,
  SSOWItemsLoading: bool,
  readingList: arrayOf(
    shape({
      title: string.isRequired,
      link: string.isRequired,
      agreementText: string.isRequired,
    })
  ),
  SSOWHandBaller: arrayOf(
    shape({
      title: string.isRequired,
      link: string.isRequired,
    })
  ),
  SSOWMaterialHandling: arrayOf(
    shape({
      title: string.isRequired,
      link: string.isRequired,
    })
  ),
};

export default CarltonForestOnboarding;
